import React from 'react';
import { CgSpinnerTwoAlt } from 'react-icons/cg';

const Spinner = ({ color = 'currentColor', size = 20, className = '' }) => {
  return <CgSpinnerTwoAlt className={`animate-spin ${className}`} size={size} color={color} />;
};

export default Spinner;
